import BaseAPI from "./api";
import env from "../environment";
import {
  LoginUser,
  AuthenticationResponse,
  ErrorResponse,
  Auth3Response,
  AccessTokenResponse,
  LogoutRequestBody,
} from "../app/models/auth/loginUser";
import { AppConstants } from "../constants/AppConstants";

const API = BaseAPI?.axiosInstance;

export const authStep1 = (
  user: LoginUser,
  locale?: string
): Promise<AuthenticationResponse> => {
  const { username, password } = user;
  const headers: any = {
    [AppConstants.HEADER_X_USERNAME]: username,
    [AppConstants.HEADER_X_PASSWORD]: password,
    ...AppConstants.GLOBAL_HEADERS,
  };

  if (locale) {
    headers[AppConstants.HEADER_X_LOCALE] = locale;
  }

  const response = API.post<AuthenticationResponse>(
    `/${env.authpath}/authenticate`,
    {},
    { headers }
  ).then((res: { data: any }) => res?.data);
  return response;
};

export const authStep2 = async (step1Auth: AuthenticationResponse) => {
  const headers = { ...AppConstants.GLOBAL_HEADERS };
  const response = await API.post<AuthenticationResponse | ErrorResponse>(
    `/${env.authpath}/authenticate`,
    step1Auth,
    {
      headers,
    }
  ).then((res: any) => res);
  return response;
};

export const authStep3 = async (requestBody: AuthenticationResponse) => {
  const headers = { ...AppConstants.GLOBAL_HEADERS };
  const response = await API.post<Auth3Response>(
    `/${env.authpath}/authenticate`,
    requestBody,
    {
      headers,
    }
  ).then((res: any) => res);
  return response;
};

export const authStep4 = async (requestBody: URLSearchParams) => {
  const headers = {
    [AppConstants.HEADER_CONTENT_TYPE]:
      AppConstants.VALUE_APPLICATION_URL_ENCODED,
  };
  const response = await API.post(`/${env.authpath}/authorize`, requestBody, {
    headers,
    maxRedirects: 0,
  })
    .then((res: any) => res)
    .catch((res: any) => res);
  return response;
};

export const authStep5 = async (requestBody: URLSearchParams) => {
  const headers = {
    [AppConstants.HEADER_CONTENT_TYPE]:
      AppConstants.VALUE_APPLICATION_URL_ENCODED,
  };
  const response = await API.post<AccessTokenResponse>(
    `/${env.authpath}/access_token`,
    requestBody,
    { headers }
  ).then((res: any) => res);
  return response;
};

export const refreshToken = async (requestBody: URLSearchParams) => {
  const headers = {
    [AppConstants.HEADER_CONTENT_TYPE]:
      AppConstants.VALUE_APPLICATION_URL_ENCODED,
  };
  const response = await API.post(
    `/${env.authpath}/access_token`,
    requestBody,
    {
      headers,
    }
  ).then((res: any) => res);
  return response;
};

export const logout = async (requestBody: LogoutRequestBody) => {
  const headers = {
    ...AppConstants.GLOBAL_HEADERS,
    apikey: env.apikey,
    iPlanetDirectoryPro: localStorage.getItem(AppConstants.TOKEN_ID_COOKIE)!,
  };
  const response = await API.post(`/${env.authpath}/revoke`, requestBody, {
    headers,
  }).then((res: any) => res);
  return response;
};
